import { SmartInput } from 'app/components/shared/FormComponents/SmartInput'
import { FormGroup } from 'app/components/shared/FormGroup'
import { SponsormanStatus } from 'EstraSponsor'
import React from 'react'
import { useTheme } from 'styled-components'

export const MswDevToolsInnerForm = (): JSX.Element => {
  const theme = useTheme()

  const sponsormanStatus: {
    [key in SponsormanStatus]: string
  } = {
    incompleted: 'Incompleto',
    ready_for_registry: 'In attesa dei file',
    pending: 'In amministrazione',
    approved: 'Approvato',
    rejected: 'Rifiutato',
    completed: 'Completato',
  }

  return (
    <div>
      <FormGroup>
        <SmartInput
          label='Stato Utente'
          type='select'
          name='status'
          labelRequired
          selectCaretSize='small'
          bgColor={theme.color.neutri.grigioBg}
        >
          <option value={''}>Seleziona</option>
          {Object.keys(sponsormanStatus).map((optValue) => (
            <option key={optValue} value={optValue}>
              {sponsormanStatus[optValue as SponsormanStatus]}
            </option>
          ))}
        </SmartInput>
      </FormGroup>
    </div>
  )
}
